import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);

  // Show button when page is scrolled up to given distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set the scroll state for better UX
  const handleScroll = () => {
    setIsScrolling(true);
    
    // Clear the scrolling state after scrolling stops
    clearTimeout(window.scrollTimer);
    window.scrollTimer = setTimeout(() => {
      setIsScrolling(false);
    }, 150);
    
    toggleVisibility();
  };

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    
    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (window.scrollTimer) {
        clearTimeout(window.scrollTimer);
      }
    };
  }, []);

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className={`
            fixed bottom-6 right-6 z-50
            w-12 h-12 sm:w-14 sm:h-14
            bg-orange-500 hover:bg-orange-600 
            text-white rounded-full shadow-lg hover:shadow-xl
            flex items-center justify-center
            transition-all duration-300 ease-in-out
            transform hover:scale-110 active:scale-95
            focus:outline-none focus:ring-4 focus:ring-orange-300
            ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}
            ${isScrolling ? 'opacity-75' : 'opacity-100'}
          `}
          aria-label="Back to top"
          title="Back to top"
        >
          <ChevronUp 
            className="w-6 h-6 sm:w-7 sm:h-7" 
            strokeWidth={2.5}
          />
        </button>
      )}
    </>
  );
};

export default BackToTop;